import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a74b4d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]




export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  color: {
    type: String,
    default: 'default'
  },
  bg: {
    type: String,
    default: 'none'
  },
  border: {
    type: String,
    default: 'none'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  upperCase: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.disabled,
    class: _normalizeClass(['btn', `bg-${props.bg}`, `border-${props.border}`, `color-${props.color}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})